import {
  StyledHeader,
  // StyledImg
} from './Header.styled';

// import { data } from 'data/data';

export default function HeaderSection() {
  return (
    <StyledHeader>
      {/* <StyledImg src={data.autograph} width="400" height="50" /> */}
    </StyledHeader>
  );
}
